import { SvgIcon, type SvgIconProps } from "@mui/material";

export const CartonIcon: React.FC<SvgIconProps> = (props) => {
	return (
		<SvgIcon {...props}>
			<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M14.2 4H10.2L8.69995 8V12.1521C8.69995 12.8231 9.34777 13.3037 9.98995 13.1091L12 12.5L13.9017 13.0943C14.5456 13.2955 15.2 12.8144 15.2 12.1398V8L14.2 4Z"
					stroke="currentColor"
					strokeWidth="2"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M3.16029 6.82918L4.79849 3.55279C4.96788 3.214 5.31415 3 5.69292 3H18.4569C18.8356 3 19.1819 3.214 19.3513 3.55279L20.9895 6.82918C21.0177 6.88564 21.042 6.94266 21.0625 7H21.0749V7.03585C21.1788 7.3507 21.1705 7.6736 21.0749 7.96431V9V21C21.0749 21.5523 20.6272 22 20.0749 22H4.07488C3.5226 22 3.07488 21.5523 3.07488 21V9V7.96431C2.97923 7.6736 2.97093 7.3507 3.07488 7.03586V7H3.08722C3.10776 6.94266 3.13207 6.88564 3.16029 6.82918ZM5.31095 7H18.8388L17.8388 5H6.31095L5.31095 7ZM5.07488 9V20H19.0749V9H5.07488Z"
					fill="currentColor"
				/>
			</svg>
		</SvgIcon>
	);
};
